import Cookie, { DOMAIN } from './cookie'
import { isElectron } from './electron'
import { getUserTypeFromToken } from './user'

const electron = isElectron()

export const TOKEN_ENV_COOKIE = `TOKEN_${process.env.REACT_APP_CUSTOM_NODE_ENV}`
export const REFRESH_TOKEN_ENV_COOKIE = `REFRESH_TOKEN_${process.env.REACT_APP_CUSTOM_NODE_ENV}`
export const USER_TYPE_COOKIE = `USER_TYPE_${process.env.REACT_APP_CUSTOM_NODE_ENV}`

// function performExternalRequest(name, val) {
//     const cookieJar = electron.remote.session.defaultSession.cookies
//     const expiration = new Date()
//     let hour = expiration.getHours()
//     hour = hour + 6
//     expiration.setHours(hour)

//     const cookie = {
//         url: DOMAIN,
//         name,
//         value: val,
//         expirationDate: expiration.getTime(),
//     }

//     cookieJar
//         .set(cookie)
//         .then(() => {
//             console.log('success')
//         })
//         .catch(error => {
//             console.log('error in setting cookie - ', error)
//         })
// }

export const accessTokenHelper = {
    set: val => {
        // return Cookie.set(TOKEN_ENV_COOKIE, val)
        // performExternalRequest(TOKEN_ENV_COOKIE, val)
        if (electron) {
            return localStorage.setItem(TOKEN_ENV_COOKIE, val)
        } else {
            return Cookie.set(TOKEN_ENV_COOKIE, val)
        }
    },
    get: () => {
        if (electron) {
            return localStorage.getItem(TOKEN_ENV_COOKIE)
        } else {
            return Cookie.get(TOKEN_ENV_COOKIE)
        }
    },
    del: () => {
        if (electron) {
            return localStorage.removeItem(TOKEN_ENV_COOKIE)
        } else {
            return Cookie.remove(TOKEN_ENV_COOKIE)
        }
    },
}

export const refreshTokenHelper = {
    set: val => {
        // return Cookie.set(TOKEN_ENV_COOKIE, val)
        // performExternalRequest(TOKEN_ENV_COOKIE, val)
        if (electron) {
            return localStorage.setItem(REFRESH_TOKEN_ENV_COOKIE, val)
        } else {
            return Cookie.set(REFRESH_TOKEN_ENV_COOKIE, val)
        }
    },
    get: () => {
        if (electron) {
            return localStorage.getItem(REFRESH_TOKEN_ENV_COOKIE)
        } else {
            return Cookie.get(REFRESH_TOKEN_ENV_COOKIE)
        }
    },
    del: () => {
        if (electron) {
            return localStorage.removeItem(REFRESH_TOKEN_ENV_COOKIE)
        } else {
            return Cookie.remove(REFRESH_TOKEN_ENV_COOKIE)
        }
    },
}

export const userTypeHelper = {
    set: val => {
        // return Cookie.set(TOKEN_ENV_COOKIE, val)
        // performExternalRequest(TOKEN_ENV_COOKIE, val)
        if (electron) {
            return localStorage.setItem(USER_TYPE_COOKIE, val)
        } else {
            return Cookie.set(USER_TYPE_COOKIE, val)
        }
    },
    get: () => {
        if (electron) {
            return localStorage.getItem(USER_TYPE_COOKIE)
        } else {
            return Cookie.get(USER_TYPE_COOKIE)
        }
    },
    del: () => {
        if (electron) {
            return localStorage.removeItem(USER_TYPE_COOKIE)
        } else {
            return Cookie.remove(USER_TYPE_COOKIE)
        }
    },
}

export const setupAuthTokens = tokens => {
    accessTokenHelper.set(tokens.access_token)
    refreshTokenHelper.set(tokens.refresh_token)
    const userType = getUserTypeFromToken(tokens.access_token)
    userTypeHelper.set(userType)
}

export const removeAuthTokens = () => {
    accessTokenHelper.del()
    refreshTokenHelper.del()
    userTypeHelper.del()
}
